"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Loading = _interopRequireDefault(require("../Loading"));

var _styles = _interopRequireDefault(require("./styles"));

// ** forwardref render functions do not support proptypes or defaultprops **
// one of the reasons why we use a separate prop for passing ref instead of using forwardref
function MonacoContainer(_ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      isEditorReady = _ref2.isEditorReady,
      loading = _ref2.loading,
      _ref = _ref2._ref,
      className = _ref2.className,
      wrapperClassName = _ref2.wrapperClassName;
  return /*#__PURE__*/_react.default.createElement("section", {
    style: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _styles.default.wrapper), {}, {
      width: width,
      height: height
    }),
    className: wrapperClassName
  }, !isEditorReady && /*#__PURE__*/_react.default.createElement(_Loading.default, {
    content: loading
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: _ref,
    style: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _styles.default.fullWidth), !isEditorReady && _styles.default.hide),
    className: className
  }));
}

MonacoContainer.propTypes = {
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  loading: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]).isRequired,
  isEditorReady: _propTypes.default.bool.isRequired,
  className: _propTypes.default.string,
  wrapperClassName: _propTypes.default.string
};
var _default = MonacoContainer;
exports.default = _default;